<template lang="pug">
  div
    div(class="m-block-premium-features-stepper__image align-center")
      v-img(
        :src="require('~/assets/images/confetti.gif')"
        max-width="80"
      )
    div(class="m-block-premium-features-stepper__content")
      h2(class="title-32px fw-700 mb-2") {{ $t('14 days free. Just click and go') }}
      div(class="text-14px mb-6 fw-300") {{ $t('You can test all Premium features right now - without restrictions') }}
      div(class="m-block-premium-features-stepper__features")
        div(
          v-for="feature in features"
          :key="feature"
          class="m-block-premium-features-stepper__features-item"
        )
          e-svg-icon check-circle-primary
          span(class="text-12px dark fw-300") {{ feature }}
</template>


<script>
export default {
  name: 'OnboardingFeaturesOutroBlock',
  props: {
    features: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped lang="scss"></style>